// import React from 'react'
// import { Link } from 'react-router-dom'

// import logo from '../assets/images/logo-icon.png';
// // import { FiDribbble, FiFacebook, FiInstagram, FiLinkedin, FiMail, FiShoppingCart, FiTwitter } from 'react-icons/fi'

// export default function Footer() {
//   return (
//         <footer className="py-8 bg-slate-800 dark:bg-gray-900">
//             <div className="container">
//                 <div className="grid md:grid-cols-12 items-center">
//                     <div className="md:col-span-3">
//                     <Link className="logo-footer" to="/">
//                         <h4 className={"text-white text-2xl md:leading-normal leading-normal font-bold inline-block dark:hidden flex flex-wrap"}>
//                             <img src={logo} className="h-10" style={{marginTop:"-3px"}} /> {' '} HeartFelt 
//                         </h4>
//                     </Link>
//                     </div>

//                     <div className="md:col-span-9 md:mt-0 mt-8">
//                         <div className="text-center">
//                             <p className="text-gray-400">© {new Date().getFullYear()} HeartFelt. Design & Develop with <i className="mdi mdi-heart text-red-700"></i> by <Link to="https://devinnovations.co.in/" target="_blank" className="text-reset">Dev Innovations</Link>.</p>
//                         </div>
//                     </div>

//                     {/* <div className="md:col-span-4 md:mt-0 mt-8">
//                         <ul className="list-none foot-icon ltr:md:text-right rtl:md:text-left text-center">
//                             <li className="inline"><Link to="https://1.envato.market/HeartFelt-react" target="_blank" className="size-8 inline-flex items-center justify-center tracking-wide align-middle text-base border border-gray-700 hover:border-red-500 rounded-md text-slate-300 hover:text-white hover:bg-red-500"><FiShoppingCart  className="h-4 w-4 align-middle" title="Buy Now"/></Link></li>

//                             <li className="inline"><Link to="https://dribbble.com/shreethemes" target="_blank" className="size-8 inline-flex items-center justify-center tracking-wide align-middle text-base border border-gray-700 hover:border-red-500 rounded-md text-slate-300 hover:text-white hover:bg-red-500"><FiDribbble  className="h-4 w-4 align-middle" title="dribbble"/></Link></li>

//                             <li className="inline"><Link to="http://linkedin.com/company/shreethemes" target="_blank" className="size-8 inline-flex items-center justify-center tracking-wide align-middle text-base border border-gray-700 hover:border-red-500 rounded-md text-slate-300 hover:text-white hover:bg-red-500"><FiLinkedin className="h-4 w-4 align-middle" title="Linkedin"/></Link></li>

//                             <li className="inline"><Link to="https://www.facebook.com/shreethemes" target="_blank" className="size-8 inline-flex items-center justify-center tracking-wide align-middle text-base border border-gray-700 hover:border-red-500 rounded-md text-slate-300 hover:text-white hover:bg-red-500"><FiFacebook className="h-4 w-4 align-middle" title="facebook"/></Link></li>

//                             <li className="inline"><Link to="https://www.instagram.com/shreethemes/" target="_blank" className="size-8 inline-flex items-center justify-center tracking-wide align-middle text-base border border-gray-700 hover:border-red-500 rounded-md text-slate-300 hover:text-white hover:bg-red-500"><FiInstagram className="h-4 w-4 align-middle"/></Link></li>

//                             <li className="inline"><Link to="https://twitter.com/shreethemes" target="_blank" className="size-8 inline-flex items-center justify-center tracking-wide align-middle text-base border border-gray-700 hover:border-red-500 rounded-md text-slate-300 hover:text-white hover:bg-red-500"><FiTwitter className="h-4 w-4 align-middle" title="twitter"/></Link></li>

//                             <li className="inline"><Link to="mailto:support@shreethemes.in" className="size-8 inline-flex items-center justify-center tracking-wide align-middle text-base border border-gray-700 hover:border-red-500 rounded-md text-slate-300 hover:text-white hover:bg-red-500"><FiMail className="h-4 w-4 align-middle" title="email"/></Link></li>
//                         </ul>
//                     </div> */}
//                 </div>
//             </div>
//         </footer>
//   )
// }
import React from 'react'
import { Link } from 'react-router-dom'
import logoDark from '../assets/images/logo-dark.png'

export default function Footer() {
  return (
    <footer className="py-8 bg-red-500/5 dark:bg-red-500/5">
    <div className="container mx-auto px-4">
      <div className="flex flex-col items-center md:flex-row md:items-center md:justify-between space-y-6 md:space-y-0">
        
        {/* Logo Section */}
        <div className="flex items-center justify-center md:justify-start">
          <Link to="/" className="inline-flex items-center">
            <img src={logoDark} className="h-[80px]" alt="HeartFelt Logo" />
          </Link>
        </div>

        {/* Policy Links */}
        <div className="text-center md:text-left">
          <div className="flex flex-col sm:flex-row sm:flex-wrap justify-center gap-2 sm:gap-4">
            <Link to="/terms" className="text-white hover:text-white">Terms and Conditions</Link>
            <Link to="/privacy-policy" className="text-white hover:text-white">Privacy Policy</Link>
            {/* <Link to="/return-policy" className="text-white hover:text-white">Return / Refund / Cancellation Policy</Link> */}
          </div>
        </div>
      </div>

      {/* Copyright - On new line */}
      <div className="mt-6 text-center">
        <p className="text-white">
          © {new Date().getFullYear()} HeartFelt. Design & Develop with <i className="mdi mdi-heart text-red-700"></i> by <Link to="https://devinnovations.co.in/" target="_blank" className="text-reset underline">Dev Innovations</Link>.
        </p>
      </div>
    </div>
  </footer>
  )
}
